import axios from 'axios';

export default axios.create({
    baseURL: 'https://api.unsplash.com',
    headers: {
        Authorization: 'Client-ID SADC9xBl-jfkHaDnXUz3-eKdOnEBzXYh7VNBkNKrlUE'
    }
});